var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlmostAlways(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 209,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-929 -255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.045 204.52C82.0133 204.531 50.3633 172.899 50.3522 133.868 50.3411 94.8367 81.973 63.1866 121.004 63.1755 160.035 63.1644 191.685 94.7963 191.697 133.827 191.697 133.834 191.697 133.841 191.697 133.848 191.766 172.809 160.238 204.45 121.277 204.52 121.199 204.52 121.122 204.52 121.045 204.52ZM180.846 72.2618 188.416 64.692C191.245 61.685 191.132 56.9632 188.164 54.0942 185.243 51.2462 180.619 51.1359 177.566 53.8419L168.987 62.6734C156.983 54.5408 143.07 49.6711 128.614 48.543L128.614 37.9452 151.324 37.9452 151.324 22.8055 90.7651 22.8055 90.7651 37.9452 113.475 37.9452 113.475 48.2906C66.1424 52.4089 31.1106 94.118 35.2291 141.45 39.3474 188.782 81.0565 223.814 128.389 219.696 175.721 215.577 210.753 173.868 206.634 126.536 204.842 105.933 195.687 86.6655 180.846 72.2618Z",
    transform: "matrix(1 0 0 1.00307 899.27 239.493)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4806 133.81C60.4973 167.239 87.6105 194.325 121.039 194.308 154.468 194.291 181.554 167.178 181.538 133.749 181.521 100.344 154.445 73.2676 121.039 73.251L121.039 133.81Z",
    transform: "matrix(1 0 0 1.00307 899.27 239.493)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmostAlways);
export default __webpack_public_path__ + "static/media/almost-always.bc2a1d4946edca8250f5739759439686.svg";
export { ForwardRef as ReactComponent };